<script lang="ts">
import { ArrowLeftIcon } from '@heroicons/vue/20/solid'

export interface UiDialogPageProps {
  title: string
  submitButtonText: string
  isSubmitDisabled?: boolean
  cancelButtonText?: string | null
  isLoading?: boolean
  hasBackIcon?: boolean
}

type UiDialogPageEmits = {
  submit: []
  cancel: []
}

interface Slots {
  default(): unknown
}
</script>

<script lang="ts" setup>
const { isSubmitDisabled = false, cancelButtonText = null, hasBackIcon = false } = defineProps<UiDialogPageProps>()
const emit = defineEmits<UiDialogPageEmits>()
defineSlots<Slots>()

function submit(): void {
  emit('submit')
}

function cancel(): void {
  emit('cancel')
}
</script>

<template>
  <section class="relative flex flex-col gap-6">
    <header>
      <h3 class="text-lg font-bold">{{ title }}</h3>
    </header>

    <slot />

    <!-- reverse visual button order to let submit get focus first -->
    <footer class="flex flex-row-reverse gap-2">
      <button
        class="btn btn-primary dark:btn-success flex-1"
        :disabled="isSubmitDisabled"
        @click="submit"
      >
        {{ submitButtonText }}
      </button>
      <button
        class="btn btn-outline bg-base-100"
        @click="cancel"
      >
        <ArrowLeftIcon
          v-if="hasBackIcon"
          class="h-4"
        />

        {{ cancelButtonText }}
      </button>
    </footer>

    <div
      v-if="isLoading"
      class="bg-base-100/60 absolute top-0 left-0 z-10 flex h-full w-full items-center justify-center"
    >
      <div class="loading loading-spinner" />
    </div>
  </section>
</template>
